<template>
  <div class="mt-4">
    <div class="overline text-center">Filter Categories</div>
    <v-divider></v-divider>

    <div>
      <v-list dense shaped color="transparent">
        <v-list-item-group color="primary" dense v-model="selected">
          <v-list-item
            dense
            v-for="(category, index) in categoryOptions"
            :key="index"
            @click="setMode(category.value)"
          >
            <v-list-item-content dense>
              <v-list-item-title dense>{{ category.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group></v-list
      >
    </div>
  </div>
</template>

<script>
import ReferencesOptions from "@/assets/js/Pages/ReferencesOptions";
import FiltersMixin from "@/assets/js/cls/FiltersMixin.js";

export default {
  components: {},
  name: "ReferencesMenuBtns",
  mixins: [FiltersMixin],
  props: {
    currentModule: null,
  },
  data: function () {
    return { selected: 0, page: null };
  },
  methods: {
    setMode(category) {
      this.$store.dispatch("setModeAndDetail", {
        mode: category,
        detail: null,
      });
    },
    setSelected(category) {
      let catIndex = this.indexForCategory[category];
      this.selected = catIndex;
    },
  },
  computed: {
    categoryOptions: function () {
      let rtn = null;
      if (this.currentModule == "clinical-references")
        rtn = ReferencesOptions.tableCategoryOptions;
      if (this.currentModule == "educational-images")
        rtn = ReferencesOptions.ed_imageCategoryOptions;

      return rtn;
    },
    storedCategory: function () {
      return this.$store.state.mode;
    },
    indexForCategory: function () {
      let rtn = [];
      let categories = this.categoryOptions;
      let cnt = this.categoryOptions.length;
      for (var i = 0; i < cnt; i++) {
        rtn[categories[i].value] = i;
      }
      return rtn;
    },
  },
  watch: {
    storedCategory(val) {
      // console.log("setcategory");
      this.setSelected(val);
    },
  },
  mounted() {
    if (this.storedCategory) this.setSelected(this.storedCategory);
  },
};
</script>

<style scoped></style>
